import faqs from "./faq.config"
import deepMergeObjects from "../assets/helpers/mergeObjects.js"
export default deepMergeObjects(faqs, {
	legacy: false,
	locale: "en",
	messages: {
		en: {
			//TODO: Maintain Alphabetical order!!!
			accept: "Accept",
			accountUnconfirmedAddress: "Please be advised that your address information may be out of date. Please 'Edit' and then 'Save' your information below.",
			address2: "Address 2",
			address: "Address",
			addressInvalid: "Invalid Address",
			agreeToAll: "Agree to All",
			apiSuccess: "Successfully Updated",
			back: "Back",
			backToSite: "Go Back To Site",
			balanceOwing: "Balance Owing",
			billingAddress: "Billing Address",
			buyMerch: "Buy Merch",
			buyTickets: "Buy Tickets",
			cancel: "Cancel",
			cardCVVCode: "CVV",
			cardCVVCodeInvalid: "Invalid CVV",
			cardExpirationDate: "Expiration Date",
			cardExpirationDateInvalid: "Invalid Expiration Date",
			cardNumber: "Card Number",
			cardNumberInvalid: "Invalid Card Number",
			changePassword: "Change Password",
			changePasswordConfirm: "Confirm New Password",
			changePasswordConfirmInvalid: "Passwords do not match",
			changePasswordCurrent: "Current Password",
			changePasswordCurrentInvalid: "Type in your current password",
			changePasswordNew: "New Password",
			changePasswordNewInvalid: "Your password must be a minimum of 6 characters",
			city: "City",
			cityInvalid: "Invalid City",
			claim: "Claim",
			claimed: "Claimed",
			claimedDisabled: "Claiming is not enabled yet, please watch for an announcement from us.",
			claimedItems: "Claimed Items:",
			claimedItemsNote: "These are the items associated to this QR Code.",
			claimedQrNote: "Present your QR Code at the gate for entry",
			claimItems: "Claim Items",
			claimItemsHelp: "Complete the claiming process to generate your QR Code for your next event. <br><br> Claimed items will be held exclusively for your use and cannot be used by another patron.",
			claimItemsNameWarning: "Please remember to bring two pieces of ID, including one government-issued photo ID. The name on your photo ID must match the name above.",
			claimItemsTransfer: "If you purchased items for someone else, please transfer the items to your guest.",
			claimingNotEnabledForEvent: "Claiming is not currently enabled for this event.",
			claimStep1: "Event",
			claimStep1Select: "Select Event",
			claimStep2: "Ticket",
			claimStep2OtherItems: "Note: All other items types such as Parking and Add-ons cannot be claimed. They will always be transferable and auto-claimed upon entering the festival grounds.",
			claimStep2Select: "Select Items",
			claimStep2SelectedLodging: "Lodging Selected:",
			claimStep2SelectedTicket: "Ticket Selected:",
			claimStep2SelectLodging: "Select Lodging:",
			claimStep2SelectTicket: "Select Ticket:",
			claimStep3: "Lodging",
			claimStep3Confirm: "Please acknowledge the following:",
			claimStep3LodgingHelp: "Select the lodging you will use, or continue without claiming lodging.",
			claimStep3Select: "You're about to claim:",
			claimStep3SelectLodging: "Select Lodging:",
			claimStep3SkipLodging: "I do not want to claim lodging",
			claimStep3Warning: "Note: Claiming your items will reserve the items for your use only. The items will not be transferable until unclaimed.",
			claimStep4: "Claim",
			claimSuccess: "Items Claimed",
			claimTerm1: "I will bring two pieces of ID, including one government-issued photo ID that matches the name listed in this User Portal.",
			claimTerm2: "I acknowledge that I cannot buy or sell a printed or downloaded ticket, lodging, or credential of any kind. No exceptions. All items must be transferred through this User Portal.",
			claimTerm3: "I will bring the QR Code generated in the next step in either printed form or via the portal or screen capture and will not transfer away those credentials if I intend to use them or I will not be able to access the festival.",
			claimTerm4: "I have read and agreed to the Terms and Conditions.",
			confirm: "Confirm",
			confirmEmail: "Confirm Email",
			confirmEmailInvalid: "Emails do not match",
			confirmPassword: "Confirm Password",
			cookiesNotice: "We use analytical tools to help make your experience better. We’d love to have you accept our cookies but we’ll always respect your data choices. Some cookies are necessary for our page to work.",
			country: "Country",
			countryInvalid: "Invalid Country",
			days: "days",
			decline: "Decline",
			detectedTranslatorBody: "We've detected that you are using a translator. While you are welcome to continue, please note that translations have caused issues for some users. If you experience any errors or problems, we recommend switching back to English for the best experience.",
			detectedTranslatorTitle: "Translator Detected",
			discounts: "Discount",
			discountCodeUsed: "code",
			dismiss: "Dismiss",
			done: "Done",
			download: "Download",
			downloadInvoice: "Download Invoice",
			dropdownPlaceholder: "Select",
			dueDate: "Due Date",
			edit: "Edit",
			email: "Email",
			emailInvalid: "Please enter a valid Email",
			emailInvoice: "Email Invoice",
			emailInvoiceSuccess: "We have resent your order receipt, please check your email inbox",
			errorPageMissingBody: "The page you are looking for does not exist",
			errorPageMissingTitle: "Page Not Found",
			errorPageBody: "Sorry! Please try again and if the error persists then please contact support.",
			errorPageTitle: "We encountered an error",
			errorPopupDefaultBody: "Something went wrong",
			errorPopupDefaultTitle: "Error",
			errorUpdatingImage: "Sorry, something went wrong. Please try again or use a different image.",
			eventName: "Shambhala",
			faq: "FAQs",
			faqGo: "Go to FAQs",
			faqTip: "Learn how to easily manage your tickets and lodging as well as transfers to friends & family.",
			faqTitle: "Frequently Asked Questions",
			firstName: "First Name",
			firstNameInvalid: "Invalid First Name",
			forgotPassword: "Forgot Password?",
			forgotPasswordPageBody: "Type in your email below to reset your password:",
			forgotPasswordPageTitle: "Forgot Your Password?",
			forgotPasswordSuccessBody: "If an account with that email is found, you will receive a password reset email shortly.",
			forgotPasswordSuccessTitle: "Check Your Inbox",
			gst: "GST",
			home: "Home",
			homeItemCount: "TODO",
			homeOverduePayment: "Please be advised that you have an overdue payment and immediate action is required.",
			homeWelcome: "Welcome, {name}!",
			hours: "hours",
			installmentNum: "Installment #: {num}",
			installments: "Installments",
			installmentsCanceled: "Cancelled",
			installmentsChangedAlready: "This installment was already extended and cannot be extended again.",
			installmentsChangeDueDate: "Change Payment Date",
			installmentsChangeDueDateTip: "You may extend a payment date once",
			installmentsCompleted: "Completed",
			installmentsCurrentDueDate: "Current Due Date",	
			installmentsErrorMessage: "Error Message",	
			installmentsOriginalDueDate: "Original Due Date",
			installmentsOthers: "Others",
			installmentsPastDue: "Past Due",
			installmentsProcessing: "Payment is being processed...",
			installmentsRefunded: "Refunded",
			installmentsSelectDueDate: "Change Due Date",
			installmentsUpcoming: "Upcoming",
			invalidCredentials: "Invalid Credentials",
			item: "Item",
			items: "Items",
			itemCount: {
				"none": "You don't have tickets to the next event!",
				"base": "Congrats! You have your ticket.",
				"base_lodging": "Congrats! You have your ticket and {lodgingCount} lodging package.",
				"base_lodgings": "Congrats! You have your ticket and {lodgingCount} lodging packages.",
				"base_upgrade": "Congrats! You have your ticket and {upgradeCount} upgrade.",
				"base_upgrades": "Congrats! You have your ticket and {upgradeCount} upgrades.",
				"base_extraTicket": "Congrats! You have your ticket and {extraTicketCount} extra ticket.",
				"base_extraTickets": "Congrats! You have your ticket and {extraTicketCount} extra tickets.",
				"base_lodging_upgrade": "Congrats! You have your ticket, {lodgingCount} lodging package, and {upgradeCount} upgrade.",
				"base_lodgings_upgrade": "Congrats! You have your ticket, {lodgingCount} lodging packages, and {upgradeCount} upgrade.",
				"base_lodging_upgrades": "Congrats! You have your ticket, {lodgingCount} lodging package, and {upgradeCount} upgrades.",
				"base_lodgings_upgrades": "Congrats! You have your ticket, {lodgingCount} lodging packages, and {upgradeCount} upgrades.",
				"base_lodging_extraTicket": "Congrats! You have your ticket, {lodgingCount} lodging package, and {extraTicketCount} extra ticket.",
				"base_lodgings_extraTicket": "Congrats! You have your ticket, {lodgingCount} lodging packages, and {extraTicketCount} extra ticket.",
				"base_lodging_extraTickets": "Congrats! You have your ticket, {lodgingCount} lodging package, and {extraTicketCount} extra tickets.",
				"base_lodgings_extraTickets": "Congrats! You have your ticket, {lodgingCount} lodging packages, and {extraTicketCount} extra tickets.",
				"base_upgrade_extraTicket": "Congrats! You have your ticket, {upgradeCount} upgrade, and {extraTicketCount} extra ticket.",
				"base_upgrades_extraTicket": "Congrats! You have your ticket, {upgradeCount} upgrades, and {extraTicketCount} extra ticket.",
				"base_upgrade_extraTickets": "Congrats! You have your ticket, {upgradeCount} upgrade, and {extraTicketCount} extra tickets.",
				"base_upgrades_extraTickets": "Congrats! You have your ticket, {upgradeCount} upgrades, and {extraTicketCount} extra tickets.",
				"base_lodging_upgrade_extraTicket": "Congrats! You have your ticket, {lodgingCount} lodging package, {upgradeCount} upgrade, and {extraTicketCount} extra ticket.",
				"base_lodgings_upgrade_extraTicket": "Congrats! You have your ticket, {lodgingCount} lodging packages, {upgradeCount} upgrade, and {extraTicketCount} extra ticket.",
				"base_lodging_upgrades_extraTicket": "Congrats! You have your ticket, {lodgingCount} lodging package, {upgradeCount} upgrades, and {extraTicketCount} extra ticket.",
				"base_lodging_upgrade_extraTickets": "Congrats! You have your ticket, {lodgingCount} lodging package, {upgradeCount} upgrade, and {extraTicketCount} extra tickets.",
				"base_lodgings_upgrades_extraTicket": "Congrats! You have your ticket, {lodgingCount} lodging packages, {upgradeCount} upgrades, and {extraTicketCount} extra ticket.",
				"base_lodging_upgrades_extraTickets": "Congrats! You have your ticket, {lodgingCount} lodging package, {upgradeCount} upgrades, and {extraTicketCount} extra tickets.",
				"base_lodgings_upgrade_extraTickets": "Congrats! You have your ticket, {lodgingCount} lodging packages, {upgradeCount} upgrade, and {extraTicketCount} extra tickets.",
				"base_lodgings_upgrades_extraTickets": "Congrats! You have your ticket, {lodgingCount} lodging packages, {upgradeCount} upgrades, and {extraTicketCount} extra tickets.",
			},
			itemsExtraWarning: "You have more items than you can claim for yourself. Make sure to transfer the extras to your friends!",
			lastName: "Last Name",
			lastNameInvalid: "Invalid Last Name",
			loading: "Loading...",
			loadingQr: "Generating your QR Code...",
			loggedOutInactive: "Your session has expired",
			loginEmail: "Email",
			loginPassword: "Password",
			logout: "Sign Out",
			maintenance1: "Our site is down for maintenance as we are working hard to improve your experience",
			maintenance2: "We are sorry for any inconveniences",
			maintenanceBtn: "Back to Site",
			messageBoard: "Message Board",
			messageBoardNone: "You have no messages at this time. Keep an eye out for future updates.",
			mins: "mins",
			more: "Menu",
			myAccount: "My Account",
			myQrCode: "My QR Code",
			myItems: "My Items",
			myOrders: "My Orders",
			myTickets: "My Tickets",
			na: "N/A",
			name: "Name",
			newPassword: "New Password",
			next: "Next",
			nextInstallment: "Next Installment",
			noEvent: "No Event",
			noNextEvent: "Keep an eye out for our next event!",
			noPurchases: "We were unable to retrieve any data for this account.",
			noQrEvents: "No recent or upcoming events with tickets are available for QR display.",
			noTicket: "You do not have a ticket for {event}. Please visit our Ticket Portal to purchase one.",
			ok: "Ok",
			order: "Order",
			orderDetails: "Order Details",
			orderId: "Order ID - {id}",
			orderSummary: "Order Summary",
			orderTotal: "Order Total",
			originalDueDate: "Original Due Date",
			otherItems: "Other Items",
			otherItemsNone: "This order has no items associated to it. Please contact support if you think this is wrong.",
			otherOrders: "Other Orders",
			overdueAmount: "Overdue Amount",
			overdueInstallment: "Overdue Installment",
			paid: "Paid",
			password: "Password",
			payInstallmentNow: "Pay Installment Now",
			payNow: "Pay Now",
			paymentAmount: "Payment Amount",
			qrStepSelectEvent: "Select Event",
			pending: "Pending",
			pendingAmount: "Next Payment",
			pendingOrders: "Pending Orders",
			pendingOrdersNone: "You have no pending orders right now or all your orders have been paid in full.",
			phone: "Phone Number",
			phoneInvalid: "Invalid Phone Number",
			profile: "Profile",
			profileImageChoose: "Select Image",
			profileImageUpload: "Update Your Profile Image",
			pst: "PST",
			redeemed: "Redeemed",
			redeemedItems: "Redeemed Items:",
			refresh: "Refresh",
			refundableBooking: "Refundable Booking",
			refundableBookingLink: "Request a Refund",
			remaining: "Remaining",
			resellItems: "Resell your items on TicketSwap",
			resetPassword: "Reset Password",
			resetPasswordPageBody: "Type in your new password:",
			resetPasswordPageTitle: "Reset Your Password",
			resetPasswordSuccessMsg: "Password was successfully reset",
			save: "Save",
			search: "Search",
			secs: "secs",
			seePastEvents: "See Past Events",
			seeYou: "See you at",
			sendResetEmail: "Send Reset Email",
			serverError: "Server Error",
			shippedItems: "Shipped Items",
			shippingAddress: "Shipping Address",
			signIn: "Sign In",
			siteNotificationMsg: "Welcome to the New User Portal! We've made it easier for you to manage your orders, transfer items and download your digital ticket.",
			startTransfer: "Transfer an Item",
			startTransferBody: "Transfer ownership of a purchased ticket or item to another person.",
			startTransferBtn: "Start",
			state: "Province",
			stateInvalid: "Invalid Province",
			subtotal: "Subtotal",
			termsAndConditions: "Terms & Conditions",
			testSiteWarning: "This is our testing site. Changes made on this site are NOT valid and will NOT be honored.",
			ticketswapLink: "Go To Ticketswap",
			ticketswapLocked: "For Sale",
			ticketswapLockedCredTransfer: "The following items are posted for sale on Ticketswap and cannot be transferred. Please cancel the listing before transferring the item:",
			ticketswapLockedCredClaim: "The following items are posted for sale on Ticketswap and cannot be claimed. Please cancel the listing before claiming the item:",
			total: "Total",
			transfer: "Transfer",
			transferAgain: "Start Another Transfer",
			transferComplete: "Transfer Complete",
			transferCompleteReview: "Your items have been successfully transferred. A confirmation email has been sent to {email}.",
			transferItems: "Transfer Items",
			transferNothingToTransfer: "You must own an item for an event in the future to begin a transfer",
			transferStep1: "Event",
			transferStep1Select: "Select Event",
			transferStep1SelectHelp: "Select which event you want to transfer away items for",
			transferStep2: "Items",
			transferStep2ClaimedItems: "Claimed Items",
			transferStep2ClaimedItemsNote: "You have claimed the following items for yourself. If you are no longer planning to attend the festival, you must unclaim the items before transferring them away:",
			transferStep2GroupedItems: "The following items will also be transferred as a package:",
			transferStep2NonTransferableItemsNote: "The following items are non-transferable:",
			transferStep2Select: "Select Items",
			transferStep2SelectHelp: "Select which item(s) that you want to transfer away",
			transferStep3: "Recipient",
			transferStep3Select: "Transfer To",
			transferStep3SelectHelp: "Type in the information of the person that you will be transferring the items to. A new account will be created for the user if they do not have one.\n\nTransfers cannot be undone, so please ensure that the information entered is correct.",
			transferStep4: "Confirm",
			transferStep4Confirm: "Please Confirm",
			transferStep4Select: "Review your transfer",
			transferStep4SelectHelp: "Please double check your transfer details below are correct and agree to the transfer terms. Transfers cannot be undone.",
			transferStep4Warning: "Please make sure you aren't transferring away your own items if you plan on attending.",
			transferSuccess: "Items Successfully Transferred",
			transferTerm1: "You agree that transferring items will permanently remove them from your account and have verified that items listed for transfer are correct",
			transferTerm2: "You agree that you are responsible for items transferred in error or to a third party",
			unclaim: "Unclaim",
			unclaimItems: "Unclaim All Items",
			unclaimSuccess: "All items have been unclaimed",
			until: "until",
			updatePaymentMethod: "Update Payment Method",
			useCard: "Use Card",
			useCardInFuture: "Apply to remaining payments on this order",
			userPortalLogin: "Login to the New User Portal",
			viewAll: "View All",
			viewInstallments: "View Installments",
			viewLess: "Show Less",
			viewMore: "View More",
			viewNone: "Collapse All",
			viewOrder: "View Order",
			yes: "Yes",
			zip: "Zip Code",
			zipCan: "Postal Code",
			zipInvalid: "Invalid Zip Code",
			zipCanInvalid: "Invalid Postal Code",
		},
		fr: {},
	},
})
